import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AccountType, CurencyID, FundDetails, MutualFund } from 'src/app/models/mutualFund';
import { Account, ClientData } from 'src/app/screens/user-profile/client-data';
import { ApiService } from 'src/app/services/api.service';
import { OrderService } from 'src/app/services/order.service';
import { UrlConstants } from 'src/app/models/urlConstants';
import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { CommissionResponse } from 'src/app/models/commission-response';

@Component({
  selector: 'app-fund-acc-order-modal',
  templateUrl: './fund-acc-order-modal.component.html',
  styleUrls: ['./fund-acc-order-modal.component.scss']
})
export class FundAccOrderModalComponent implements OnInit {
  lang: string;
  isBuy: boolean = false;
  numberOfAccounts: number = 0;
  accountSelected: boolean = false;
  typeSelected: string = null;
  type: string = 'success';
  accountList: Account[];
  selectedAccount: Account;
  relationCode: string;
  isLoading: boolean = false;
  selectedFund: MutualFund;
  fundDetails: FundDetails;
  isStep1Completed: boolean = false;
  isStep2Completed: boolean = false;
  selectedAccountRealtionCode: any;
  userPortfolio: ClientData;
  EgpPurchasePower: any;
  UsdPurchasePower: any;
  custodianList: any;
  inputCustodian: any;
  avgCommission: number;
  minCommission: number;
  minCommissionUSD: number;
  sendingOrder: boolean = false;
  isSendingOrder:boolean = false;
  minQtyCertificateBuy: number;
  minCashBuy: number;
  minCashSell:number;
  maxSellCash:number;
  minQtyCertificateSell: number;
  isLessThanMin: boolean = false;
  isMoreThanMax: boolean = false;
  orderValue: number;
  orderTotal: number;
  orderFees: number;
  currentDate: string;
  totalCost: number;
  finalQty:number;
  maxQuantiyEGP:number;
  maxQuantiyUSD:number
  maxCashEGP:number;
  maxCashUSD:number
  maxQuantity:number;
  quantityAvailable:number;
  isRequestLoading:boolean;
  selectAccountDisabled:boolean;
  FUND: number = AccountType.FUND;
  quantity:number;
  quantityControl = new FormControl('', [
    Validators.required,
    Validators.pattern(/^-?\d*$/)
  ])
  cashControl = new FormControl('', [
    Validators.required,
    Validators.pattern(/^-?\d*$/)
  ])
  stepper: any;
  cannotSell: boolean = false;
  avbSetteledQty: number;
  maxClicked: boolean;


  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public translate: TranslateService,
    public dialogRef: MatDialogRef<FundAccOrderModalComponent>,
    private cdr: ChangeDetectorRef,
    private apiService: ApiService,
    private toastr: ToastrService,
    private http: HttpClient,
    private orderService: OrderService,
    private datePipe: DatePipe
  ) {
    this.lang = this.translate.currentLang
    this.isBuy = this.data['isBuy']
    this.accountList = JSON.parse(localStorage.getItem("accList"))
    .filter(account => account.accountType === AccountType.FUND);
    this.numberOfAccounts = this.accountList ? this.accountList.length : 0;
    this.selectedAccount = this.numberOfAccounts == 1 ? this.accountList[0] : null;
    this.relationCode = JSON.parse(localStorage.getItem('userProfile')).RelationCode;
    this.selectedFund = this.data['selectedFund']
    this.fundDetails = this.data['fundDetails']
    this.quantityAvailable = this.data['quantityAvailable']
    this.minQtyCertificateBuy = this.fundDetails.BuyMinimumCertificate;
    this.minQtyCertificateSell = this.fundDetails.SellMinimumCertificate;
  }


  ngOnInit(): void {
    if(this.numberOfAccounts == 1){
      this.fetchUserPortfolio(this.selectedAccount);
    }
    this.getCommission()

    this.quantityControl.valueChanges.subscribe((value) => {
      this.handleQuantityChange(value);
    });
    this.cashControl.valueChanges.subscribe((value) => {
      this.maxClicked = false;
      this.handleCashChange(value);
    });

  }

  getCommission(){
    this.isRequestLoading=true;
    this.orderService.fetchCommissions().subscribe(
      (res: CommissionResponse) => {
        if(res){
          this.avgCommission = res.AvgCommission;
          this.minCommission = res.MinCommission;
          this.minCommissionUSD = res.MinCommissionUSD;
          this.isRequestLoading=false;
        }
      }
    );
  }


  get isValidOrder() {
    return (
      this.orderTotal <=
      (this.fundDetails.CurencyID == 2
        ? this.UsdPurchasePower
        : this.EgpPurchasePower) && this.orderTotal > 0
    );
  }
  get isButtonDisabled() {
    if (this.isBuy) {
      return (
        !this.isValidOrder ||
        this.orderValue <= 0 ||
        this.isLessThanMin ||
        this.isMoreThanMax
      );
    } else {
      if (this.typeSelected === 'CERTIFICATE') {
        if (
          this.quantityControl.value == null ||
          this.quantityControl.value <= 0 ||
          this.quantityControl.value < this.minQtyCertificateSell ||
          this.quantityControl.value > this.quantityAvailable
        ) {
          return true;
        }
      }

      if (this.typeSelected === 'CASH') {
        if (
          this.cashControl.value > this.maxSellCash ||
          this.cashControl.value > parseFloat((this.quantityAvailable * this.fundDetails.ClosePrice).toFixed(2)) ||
          this.cashControl.value <= 0||
          this.cashControl.value < this.minCashSell
        ) {
          return true;
        }
      }
    }

    return false;
  }



  openFundAccount() {
    this.isRequestLoading=true;
    const MAINCODE = 0
    this.apiService.OpenNewFundAccountRequest(MAINCODE, this.relationCode)
      .subscribe(
        (res) => {
          this.toastr.success("", this.translate.instant("fund-request-success-msg"), {
            timeOut: 15000,
            positionClass: "toast-bottom-center",
            closeButton: true,
          });
          this.isRequestLoading=false;
        }, (err) => {
          this.toastr.error("", this.translate.instant("error-msg"), {
            timeOut: 15000,
            positionClass: "toast-bottom-center",
            closeButton: true,
          });
          this.isRequestLoading=false;
        }
      )
    this.dialogRef.close();
  }

  calculateMax(clicked: boolean, cash: boolean, balance?: number, qty?: number, init?: boolean): void {
    if (this.isBuy) {
      this.calculateBuyMax(clicked, cash, balance, qty);
    } else {
      this.calculateSellMax(clicked, cash, balance, qty, init);
    }
    this.cdr.detectChanges();
  }

  private calculateBuyMax(clicked: boolean, cash: boolean, balance?: number, qty?: number): void {
    this.maxClicked = clicked
    const Balance = balance != null
      ? balance
      : this.fundDetails.CurencyID === 1
        ? this.EgpPurchasePower
        : this.UsdPurchasePower;

    const MaxQuantity = qty != null
      ? qty
      : Math.floor(Balance / this.fundDetails.ClosePrice);

    const negativeBalance = Balance < 0;
    const { result: maxQuantity, totalCost } = this.calculateMaxQuantity(Balance, MaxQuantity);

    if (qty == null && balance != null) {
      this.maxQuantity = maxQuantity;
    }
    if(cash && qty!=null){
      this.minCashBuy=  totalCost;
    }
    this.updateMaxValues(cash, maxQuantity, totalCost,qty,balance);

    if (clicked && !negativeBalance) {
      cash ? this.handleCashChange(Balance.toString()) : this.handleQuantityChange(maxQuantity.toString());
    }
  }

  private calculateSellMax(clicked: boolean, cash: boolean, balance?: number, qty?: number, init?: boolean): void {
    this.maxClicked = clicked
    let Balance;
    let MaxQuantity;

    if (!init) {
      Balance = balance != null
        ? balance
        : this.quantityAvailable / this.fundDetails.ClosePrice;

      MaxQuantity = qty != null
        ? qty
        : Math.floor(Balance / this.fundDetails.ClosePrice);

        const negativeBalance = Balance < 0;
        const { result: maxQuantity, totalCost } = this.calculateMaxQuantity(Balance, MaxQuantity);
        //const orderValue = MaxQuantity * this.fundDetails.ClosePrice;

      if (qty == null && balance != null) {
        this.maxQuantity = maxQuantity;
      }
      if(cash && qty!=null){
        this.minCashSell=  totalCost;
      }

      if (clicked) {
        MaxQuantity = this.quantityAvailable;
        cash ? this.handleCashChange(Balance.toString()) : this.handleQuantityChange(MaxQuantity.toString());
      }
    } else {
      Balance = this.quantityAvailable * this.fundDetails.ClosePrice;
      this.maxSellCash = Balance;
      this.orderValue = Balance;
      this.orderTotal = this.orderValue - this.orderFees;

      if (clicked) {
        const truncatedValue = Math.floor(Balance * 100) / 100;
        cash ? this.cashControl.setValue(truncatedValue.toString(), { emitEvent: false }) : this.handleQuantityChange(MaxQuantity.toString());
      }
    }
  }

  private calculateMaxQuantity(Balance: number, MaxQuantity: number): { result: number; totalCost: number } {
    let low = 0;
    let high = MaxQuantity;
    let result = 0;
    let totalCost = 0;

    while (low <= high) {
      const mid = Math.floor((low + high) / 2);
      const orderValue = mid * this.fundDetails.ClosePrice;
      const fees = this.calculateFees(orderValue);

      totalCost = orderValue + fees;

      if (totalCost <= Balance) {
        result = mid;
        low = mid + 1;
      } else {
        high = mid - 1;
      }
    }

    return { result, totalCost };
  }

  private calculateFees(orderValue: number): number {
    switch (this.fundDetails.ExpenseType) {
      case 1:
        return  parseFloat((orderValue * (this.fundDetails.PercentValue / 100)).toFixed(2));
      case 2:
        return this.fundDetails.FixedValue;
      case 3:
        let fees =  parseFloat((orderValue * (this.fundDetails.PercentValue / 100)).toFixed(2));
        if (this.fundDetails.Minimum !== 0 && fees < this.fundDetails.Minimum) {
          fees = this.fundDetails.Minimum;
        } else if (this.fundDetails.Maximum !== 0 && fees > this.fundDetails.Maximum) {
          fees = this.fundDetails.Maximum;
        }
        return fees;
      default:
        return 0;
    }
  }

  private updateMaxValues(cash: boolean, maxQuantity: number, totalCost: number,qty :number, balance:number): void {
    if (!cash) {
      if (this.fundDetails.CurencyID === 1) {
        this.maxQuantiyEGP = maxQuantity;
      } else {
        this.maxQuantiyUSD = maxQuantity;
      }
    } else {
      if(qty==null && balance==null)
      {
      if (this.fundDetails.CurencyID === 1) {
        this.maxCashEGP = totalCost;
      } else {
        this.maxCashUSD = totalCost;
      }
    }
    }
  }

  fetchUserPortfolio(selectedAcc?): Promise<void> {
    this.isRequestLoading=true;
    return new Promise<void>((resolve, reject) => {

      if (selectedAcc) {
        this.selectedAccountRealtionCode = selectedAcc?.relationCode;
        if (!this.selectedAccountRealtionCode) {
          reject('Invalid selected account or relationCode');
          return;
        }
      }


      this.http
        .get(`${UrlConstants.backofficeUrl}/api/Client/GetClientInformation?relationCode=${this.selectedAccountRealtionCode}`)
        .subscribe(
          (res) => {
            this.isRequestLoading=true;
            this.userPortfolio = res as ClientData;
              if(!this.isBuy && this.fundDetails){
                if(this.fundDetails.CurencyID ==  CurencyID.EGP){
                  this.cannotSell = this.userPortfolio?.Portfolio?.EGPPortfolio?.Portfolio.find((item)=> item.ReutersCode == this.fundDetails.ReutersCode)?.AvbSetteledQty > 0 ? false : true;
                  this.avbSetteledQty = this.userPortfolio?.Portfolio?.EGPPortfolio?.Portfolio.find((item)=> item.ReutersCode == this.fundDetails.ReutersCode)?.AvbSetteledQty
                } else if (this.fundDetails.CurencyID ==  CurencyID.USD){
                  this.cannotSell = this.userPortfolio?.Portfolio?.USDPortfolio?.Portfolio.find((item)=> item.ReutersCode == this.fundDetails.ReutersCode)?.AvbSetteledQty > 0 ? false : true;
                  this.avbSetteledQty = this.userPortfolio?.Portfolio?.USDPortfolio?.Portfolio.find((item)=> item.ReutersCode == this.fundDetails.ReutersCode)?.AvbSetteledQty
                }
                if(this.cannotSell){
                  this.accountSelected = false;
                  this.toastr.error("", this.translate.instant("noStocksToSell"), {
                    timeOut: 15000,
                    positionClass: "toast-bottom-center",
                    closeButton: true,
                  });
                } else {
                  this.accountSelected = true;
                }
              }
            this.EgpPurchasePower = this.userPortfolio.PurchasePower.purchasePower.EGP || 0;
            this.UsdPurchasePower = this.userPortfolio.PurchasePower.purchasePower.USD || 0;
            if(!this.isBuy){
              this.calculateMax(false,true,null,this.minQtyCertificateSell,false);
              this.calculateMax(false,true,null,null,true);
            }
            else{
              this.calculateMax(false,true,null,this.minQtyCertificateBuy,false);
            }
            if(this.typeSelected=="CERTIFICATE"){
            this.calculateMax(false,false,null,null,false);
            }
            else{
              this.calculateMax(false,true,null,null,false);
            }
            this.fetchCustodianList(selectedAcc);
          },
          (err) => {
            reject(err);
            this.isRequestLoading=false;
          }
        );



    });

  }
  fetchCustodianList(selectedAcc?): Promise<void> {
    this.isRequestLoading=true;
    return new Promise<void>((resolve, reject) => {
      if (selectedAcc) {
        this.selectedAccountRealtionCode = selectedAcc.relationCode;
      }

      if (!this.selectedAccountRealtionCode) {
        reject('Invalid selected account or relationCode');
        return;
      }

      this.http
        .get(`${UrlConstants.backofficeUrl}/api/Client/GetClientCustodianList?relationCode=${this.selectedAccountRealtionCode}`)
        .subscribe(
          (custodianRes) => {
            this.isRequestLoading=false;
            if (custodianRes) {
              this.custodianList = custodianRes;
              if (!this.inputCustodian) {
                // Ensure 'this.f' and 'this.f.custodian' are defined before calling patchValue
                if (this.f && this.f.custodian) {
                  const custodianCode = this.custodianList[0].CustodianCode;
                  this.f.custodian.patchValue(custodianCode);

                  // Log the custodianCode
                } else {
                }
              }
              this.f.execRule.patchValue(0);
              this.f.validTill.patchValue(0);
            }
            resolve();
          },
          (custodianErr) => {
            this.isRequestLoading=false;
            reject(custodianErr);
          }
        );
    });
  }


  handleInputChange(value: string, isCash: boolean): void {
    const control = isCash ? this.cashControl : this.quantityControl;
    const filteredValue = isCash
    ? value.replace(/[^0-9.]/g, '')
    : value.replace(/[^0-9]/g, '');

    if (filteredValue !== value) {
      control.setValue(filteredValue, { emitEvent: false });
      return;
    }

    if(!isCash){
        if (this.minQtyCertificateBuy !== 0) {
            const compareValue =  parseFloat(filteredValue);
            this.isLessThanMin = compareValue < this.minQtyCertificateBuy;
        }
    }
    else{
        if(this.isBuy){
            this.minCashBuy !==0? this.isLessThanMin = parseFloat(filteredValue)<this.minCashBuy:'';
        }
        else{
            this.minCashSell !=0? this.isLessThanMin = parseFloat(filteredValue)<this.minCashSell:'';
        }
    }

    const trimmedValue = isCash
    ? filteredValue.replace(/^0+(?!.)/, '')
    : filteredValue.replace(/^0+/, '') || '';
    control.setValue(trimmedValue, { emitEvent: false });

    const quantity = isCash ? this.maxQuantity : parseFloat(trimmedValue);
    this.orderValue = parseFloat((this.fundDetails.ClosePrice * quantity).toFixed(2));
    this.orderValue = isNaN(this.orderValue) || this.orderValue < 0 ? 0 : this.orderValue;
    this.quantity = quantity;

    // Set the order fees to 0 if it's not a buy order (sell order)

        switch (this.fundDetails.ExpenseType) {
            case 1:
                this.orderFees =  this.orderFees =parseFloat((this.orderValue * (this.fundDetails.PercentValue / 100)).toFixed(2));
                break;
            case 2:
                this.orderFees = this.fundDetails.FixedValue;
                break;
            case 3:
                this.orderFees =  this.orderFees =parseFloat((this.orderValue * (this.fundDetails.PercentValue / 100)).toFixed(2));
                if (this.fundDetails.Minimum !== 0 && this.orderFees < this.fundDetails.Minimum) {
                    this.orderFees = this.fundDetails.Minimum;
                } else if (this.fundDetails.Maximum !== 0 && this.orderFees > this.fundDetails.Maximum) {
                    this.orderFees = this.fundDetails.Maximum;
                }
                break;
        }

    this.orderFees = isNaN(this.orderFees) || this.orderFees < 0 ? 0 : this.orderFees;
    this.orderTotal = this.isBuy? parseFloat((this.orderValue + this.orderFees).toFixed(2)):parseFloat((this.orderValue - this.orderFees).toFixed(2));
    this.orderTotal = isNaN(this.orderTotal) || this.orderTotal < 0 ? 0 : this.orderTotal;
}


  handleCashChange(value: string): void {
    if(value.length <= 15){
      if(this.isBuy)
        this.calculateMax(false, true, parseFloat(value),null,false);
      else
        this.maxQuantity=Math.floor(parseFloat(value) / this.fundDetails.ClosePrice);
      this.handleInputChange(value, true);
    }
  }

  handleQuantityChange(value: string): void {
    this.handleInputChange(value, false);
  }


  selectAccount(account: Account, stepper: any) {
    this.accountSelected = true;
    this.selectedAccount = account;
    if(this.selectedAccount.accountType != AccountType.FUND)
    {
      this.openFundAccount();
      return;
    }
    this.fetchUserPortfolio(this.selectedAccount);
    this.cdr.detectChanges();
    stepper.next();
  }

  selectType(stepper: any, event: any, type: string) {
    this.typeSelected = type;
    this.typeSelected = type;
    this.orderValue=0;
    this.orderFees=0;
    this.orderTotal=0;
    this.cashControl.setValue('');
    this.quantityControl.setValue('');
    if(this.isBuy){
      this.typeSelected == 'CASH'? this.calculateMax(false,true,null,null,false):this.calculateMax(false,false,null,null,false);
      }
    this.cdr.detectChanges();
    stepper.next();
    const TARGET = event.currentTarget as HTMLElement;
    var tabs = document.querySelectorAll('.tab-card');
    tabs.forEach(i => i.classList.remove('selectedType'));
    let element = document.getElementById(TARGET.id);
    element?.classList.add('selectedType');
  }

 createOrder(stepper: any) {
  this.currentDate = this.datePipe.transform(new Date(), 'dd-MM-yyyy hh:mm a');
  if(this.typeSelected=='CASH'){
    this.finalQty= Math.floor((this.orderTotal-this.orderFees)/this.fundDetails.ClosePrice);
    if(this.maxClicked && !this.isBuy ){
    this.finalQty= this.quantityAvailable
    }
  }
    if(this.typeSelected=='CERTIFICATE'){
    this.finalQty= this.quantityControl.value;
    if(this.maxClicked && !this.isBuy ){
    this.finalQty= this.quantityAvailable
    }
  }
  if (this.isBuy) {

    if (!this.isValidOrder && this.orderValue > 0 && this.quantityControl.value > 0 && !this.isLoading) {
    this.isStep1Completed = false;
    this.stopNavigation(stepper);
    this.cdr.detectChanges();
    } else {
    this.isStep1Completed = true;
    this.cdr.detectChanges();
    setTimeout(() => {
      stepper.next();
    }, 0);
    }
  }
else{
  if (this.isButtonDisabled) {
  this.isStep1Completed = false;
  this.stopNavigation(stepper);
  this.cdr.detectChanges();
  } else {
  this.isStep1Completed = true;
  this.cdr.detectChanges();
  setTimeout(() => {
    stepper.next();
  }, 0);
  }
}







}

  stopNavigation(stepper: any) {
    const currentStepIndex = stepper.selectedIndex;
    stepper.selectedIndex = currentStepIndex;
  }


  submitOrder(stepper: any,type: number) {

    this.sendOrder(stepper , type)
    stepper.next();
  }

  closeModal() {
    this.dialogRef.close();
  }

  orderForm = new FormGroup({
    client: new FormControl("", Validators.required),
    qty: new FormControl("", Validators.required),
    price: new FormControl("", Validators.required),
    custodian: new FormControl("", Validators.required),
    execRule: new FormControl("", Validators.required),
    validTill: new FormControl("", Validators.required),
    tiffDate: new FormControl(new Date().setHours(0, 0, 0, 0), Validators.required),
    tiffFlag: new FormControl(),
    minFillVolume: new FormControl(),
  });


  sendOrder(stepper:any , type: number) {

    // Ensure precision for order total
    this.orderTotal = parseFloat(this.orderTotal.toFixed(2));

    // Validate purchase power
    if(
      (this.isBuy  && (this.fundDetails.CurencyID === 1 && this.EgpPurchasePower > this.orderTotal) ||
      (this.fundDetails.CurencyID === 2 && this.UsdPurchasePower > this.orderTotal))
      ||
      (!this.isBuy)
    )
     {
      this.sendingOrder = true; // Set the sending state
      this.isSendingOrder = true;
      const orderPayload = {
        SymbolCode: this.fundDetails.SymbolCode,
        Qty: this.quantityControl.value && this.quantityControl.value.trim() !== '' ? this.quantityControl.value : this.quantity,
        Price: this.fundDetails.ClosePrice,
        TakeMarketPrice: false,
        ISMSCDBook: false,
        OrderType: type,
        TiffFlag: 1,
        TiffDate: this.orderForm.get("tiffDate").value,
        FillFlag: this.orderForm.get("execRule").value,
        relationCode: this.selectedAccount.relationCode,
        CustodianCode: null,
        ApprovedStatus: type == 1 && !this.isValidOrder ? 2 : null,
        ISOPR: false,
        MinFillVolume: this.orderForm.get("minFillVolume").value,
      };

      // Send API request
      this.http.post(`${UrlConstants.backofficeUrl}/api/OfflineOrders/PostOfflineOrder`, orderPayload).subscribe({
        next: (res) => {
          if (res["Errors"]?.length > 0) {
            this.sendingOrder = false;
            this.isSendingOrder = false;
            this.toastr.error("", this.translate.instant(res["Errors"][0]), {
              timeOut: 15000,
              positionClass: "toast-bottom-center",
              closeButton: true,
            });
          } else {
            this.sendingOrder = true;
            this.isSendingOrder = false;
            this.toastr.info("", this.translate.instant("new-order-success"), {
              timeOut: 15000,
              positionClass: "toast-bottom-center",
              closeButton: true,
            });
            this.cdr.detectChanges();
            this.isStep2Completed=true;
            setTimeout(() => {
              stepper.next();
            }, 0);
          }
        },
        error: (err) => {
          this.sendingOrder = false;
          this.isSendingOrder = false;
          this.toastr.error("", this.translate.instant("order-failure"), {
            timeOut: 15000,
            positionClass: "toast-bottom-center",
            closeButton: true,
          });
      this.cdr.detectChanges();
          this.isStep2Completed=false;
        },
      });
    } else {
      this.toastr.warning("", this.translate.instant("insufficient-funds"), {
        timeOut: 15000,
        positionClass: "toast-bottom-center",
        closeButton: true,
      });
    }
  }

  isCashInputNotValid(): boolean{
    if((((!this.isValidOrder && this.orderValue > 0) ||
        ((this.fundDetails.CurencyID == 1
          ? this.EgpPurchasePower
          : this.UsdPurchasePower) < 0 &&
          !this.isLoading && this.orderTotal > 0))&& this.isBuy)
      ||((this.minCashBuy > 0 &&
          this.cashControl.value > 0 &&
          this.cashControl.value < this.minCashBuy) &&  this.isBuy) ||
          ((this.minCashSell > 0 &&
          this.cashControl.value > 0 &&
          this.cashControl.value < this.minCashSell) && !this.isBuy)
      ||(!this.isBuy && this.cashControl.value > this.maxSellCash )
    ){
      return true;
    } else {
      return false;

    }
  }

  isCertificateInputNotValid(): boolean{
    if((
      ((!this.isValidOrder && this.orderValue > 0) ||
        ((this.fundDetails.CurencyID == 1
          ? this.EgpPurchasePower
          : this.UsdPurchasePower) < 0 &&
          !this.isLoading && this.orderTotal > 0)) && this.isBuy)
      ||((this.minQtyCertificateBuy > 0 &&
        this.quantityControl.value > 0 &&
        this.quantityControl.value < this.minQtyCertificateBuy) &&  this.isBuy)
      ||((this.minQtyCertificateSell > 0 &&
        this.quantityControl.value > 0 &&
        this.quantityControl.value < this.minQtyCertificateSell) &&  !this.isBuy)
      ||this.isButtonDisabled

    ){
      return true;
    } else {
      return false;

    }
  }


  get f() {
    return this.orderForm.controls;
  }



}

